/* Todumi: requisitos del régimen courier de la aduana argentina (MailAmericas) antes de ir a pagar.
   - CUIT/CUIL obligatorio (se valida el dígito verificador y se guarda en el pedido como atributo del carrito).
   - LÍMITES (la página los aplica y explica por qué):
       · hasta 3 unidades del mismo producto por envío: si hay más, se bajan a 3 solas;
       · hasta USD 3.000 y 30 kg por envío: si se pasa, no deja ir a pagar hasta ajustar el carrito.
   - AVISO (no limita): más de USD 400 en productos paga derechos de importación además del IVA.
   Funciona en la página del producto, en la del carrito y en el carrito lateral (Horizon los vuelve a dibujar, por eso se observa el DOM). */
(function () {
  var MAX_UNIDADES = 3;
  var TOPE_ENVIO_USD = 3000;
  var MAX_KG = 30;
  var AVISO_USD = 400;
  var POR_QUE = 'Es una restricción de la aduana argentina para las compras por courier.';

  function cuitValido(v) {
    var d = String(v || '').replace(/\D/g, '');
    if (d.length !== 11 || !/^(20|23|24|25|26|27|30|33|34)/.test(d)) return false;
    var pesos = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2], s = 0;
    for (var i = 0; i < 10; i++) s += Number(d[i]) * pesos[i];
    var dv = 11 - (s % 11);
    if (dv === 11) dv = 0;
    if (dv === 10) return false;
    return dv === Number(d[10]);
  }
  function formato(v) {
    var d = String(v || '').replace(/\D/g, '').slice(0, 11);
    return d.length > 10 ? d.slice(0, 2) + '-' + d.slice(2, 10) + '-' + d.slice(10) : d;
  }
  function tasa() { return (window.Shopify && Shopify.currency && Number(Shopify.currency.rate)) || 1; }
  function leerCarrito() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function guardarSesion(k, v) { try { v ? sessionStorage.setItem(k, v) : sessionStorage.removeItem(k); } catch (e) {} }
  function leerSesion(k) { try { return sessionStorage.getItem(k) || ''; } catch (e) { return ''; } }

  var guardado = '';
  try { guardado = localStorage.getItem('todumi_cuit') || ''; } catch (e) {}

  // ---------- Carrito: campo CUIT + mensajes ----------
  function ponerCampo() {
    document.querySelectorAll('.cart__ctas').forEach(function (ctas) {
      if (ctas.previousElementSibling && ctas.previousElementSibling.classList.contains('todumi-cuit')) return;
      var caja = document.createElement('div');
      caja.className = 'todumi-cuit';
      caja.innerHTML =
        '<p class="todumi-cuit__limite" role="alert" hidden></p>' +
        '<label class="todumi-cuit__label">CUIT o CUIL del comprador <span aria-hidden="true">*</span></label>' +
        '<input class="todumi-cuit__input" inputmode="numeric" autocomplete="off" placeholder="20-12345678-9" maxlength="13">' +
        '<p class="todumi-cuit__ayuda">Lo exige la aduana argentina para importar tu compra (régimen courier). El envío y el IVA se calculan en el pago.</p>' +
        '<p class="todumi-cuit__aviso" role="status" hidden></p>' +
        '<p class="todumi-cuit__error" role="alert" hidden></p>';
      ctas.parentNode.insertBefore(caja, ctas);
      var input = caja.querySelector('input');
      input.value = formato(guardado);
      input.addEventListener('input', function () { input.value = formato(input.value); error(caja, ''); });
    });
  }
  function error(caja, msg) {
    var p = caja && caja.querySelector('.todumi-cuit__error');
    if (!p) return;
    p.textContent = msg;
    p.hidden = !msg;
  }
  function mostrar(clase, texto) {
    document.querySelectorAll('.todumi-cuit__' + clase).forEach(function (p) { p.textContent = texto; p.hidden = !texto; });
  }

  // Baja a 3 las unidades de cada producto que se pase. Devuelve los productos ajustados.
  async function aplicarLimiteUnidades(cart) {
    var porProducto = {};
    cart.items.forEach(function (it) {
      var g = porProducto[it.product_id] || (porProducto[it.product_id] = { total: 0, titulo: it.product_title, lineas: [] });
      g.total += it.quantity;
      g.lineas.push(it);
    });
    var ajustados = [];
    for (var id in porProducto) {
      var g = porProducto[id];
      if (g.total <= MAX_UNIDADES) continue;
      var sobra = g.total - MAX_UNIDADES;
      for (var i = g.lineas.length - 1; i >= 0 && sobra > 0; i--) {
        var l = g.lineas[i], nueva = Math.max(0, l.quantity - sobra);
        sobra -= l.quantity - nueva;
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: l.key, quantity: nueva }) });
      }
      ajustados.push({ titulo: g.titulo, antes: g.total });
    }
    return ajustados;
  }
  function textoAjuste(ajustados) {
    return ajustados.map(function (a) {
      return 'Pediste ' + a.antes + ' unidades de "' + a.titulo + '" y el límite es de ' + MAX_UNIDADES + ' por producto en cada envío. ';
    }).join('') + POR_QUE + ' Podés comprarlo, pero hasta ' + MAX_UNIDADES + ' unidades: ya dejamos tu carrito en ' + MAX_UNIDADES + '.';
  }
  // Tope por envío (USD 3.000 y 30 kg). Devuelve el motivo si se pasa.
  function excesoEnvio(cart) {
    var usd = cart.items_subtotal_price / 100 / tasa();
    var kg = (cart.total_weight || 0) / 1000;
    var m = [];
    if (usd > TOPE_ENVIO_USD) m.push('tu compra suma USD ' + usd.toFixed(2) + ' y el máximo por envío es USD ' + TOPE_ENVIO_USD.toLocaleString('es-AR'));
    if (kg > MAX_KG) m.push('tu compra pesa ' + kg.toFixed(1).replace('.', ',') + ' kg y el máximo por envío es ' + MAX_KG + ' kg');
    if (!m.length) return '';
    return 'No podemos enviar este carrito en un solo paquete: ' + m.join(' y ') + '. ' + POR_QUE + ' Sacá algunos productos (podés hacer otra compra aparte) para seguir.';
  }

  var controlando = false;
  async function controlar() {
    if (controlando || !document.querySelector('.todumi-cuit')) return;
    controlando = true;
    try {
      var cart = await leerCarrito();
      var ajustados = await aplicarLimiteUnidades(cart);
      if (ajustados.length) {
        // Se recarga para que el carrito muestre las cantidades nuevas; el mensaje se muestra después de recargar.
        guardarSesion('todumi_limite', textoAjuste(ajustados));
        location.reload();
        return;
      }
      var limite = [leerSesion('todumi_limite'), excesoEnvio(cart)].filter(Boolean).join(' ');
      guardarSesion('todumi_limite', '');
      mostrar('limite', limite);
      var usd = cart.items_subtotal_price / 100 / tasa();
      mostrar('aviso', usd > AVISO_USD && usd <= TOPE_ENVIO_USD
        ? 'Tené en cuenta: tu compra supera USD ' + AVISO_USD + ' en productos (USD ' + usd.toFixed(2) + '). Sobre ese monto la aduana argentina cobra derechos de importación además del IVA, y no están incluidos en el precio.'
        : '');
    } catch (e) { /* sin red: se vuelve a controlar al ir a pagar */ }
    controlando = false;
  }
  var tControl;
  function controlarLuego() { clearTimeout(tControl); tControl = setTimeout(controlar, 400); }
  document.addEventListener('cart:update', controlarLuego);

  // Intercepta el botón "Finalizar compra" (carrito y carrito lateral) antes de que Shopify lleve al checkout.
  document.addEventListener('click', async function (ev) {
    var boton = ev.target.closest && ev.target.closest('button[name="checkout"], a[href^="/checkout"]');
    if (!boton) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    var caja = document.querySelector('.todumi-cuit');
    var input = caja && caja.querySelector('input');
    var cuit = input ? input.value : '';
    if (!cuitValido(cuit)) { error(caja, 'Ingresá un CUIT o CUIL válido (11 números).'); caja && caja.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
    try {
      var cart = await leerCarrito();
      var ajustados = await aplicarLimiteUnidades(cart);
      if (ajustados.length) { guardarSesion('todumi_limite', textoAjuste(ajustados)); location.reload(); return; }
      var exceso = excesoEnvio(cart);
      if (exceso) { mostrar('limite', exceso); caja.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'CUIT/CUIL': formato(cuit) } }) });
      try { localStorage.setItem('todumi_cuit', formato(cuit)); } catch (e) {}
    } catch (e) { error(caja, 'No pudimos verificar el carrito. Probá de nuevo.'); return; }
    window.location.href = '/checkout';
  }, true);

  // ---------- Página del producto: el selector de cantidad no pasa de 3 ----------
  function notaProducto(input, mostrarla) {
    var form = input.closest('form') || input.parentNode;
    var nota = form.parentNode.querySelector('.todumi-limite-producto');
    if (!nota && mostrarla) {
      nota = document.createElement('p');
      nota.className = 'todumi-limite-producto';
      nota.setAttribute('role', 'status');
      form.parentNode.insertBefore(nota, form.nextSibling);
    }
    if (!nota) return;
    nota.textContent = 'El límite es de ' + MAX_UNIDADES + ' unidades por producto en cada envío. ' + POR_QUE + ' Podés comprarlo, pero hasta ' + MAX_UNIDADES + ' unidades.';
    nota.hidden = !mostrarla;
  }
  function limitarCantidad(input) {
    if (Number(input.value) > MAX_UNIDADES) { input.value = MAX_UNIDADES; input.dispatchEvent(new Event('change', { bubbles: true })); notaProducto(input, true); }
  }
  function prepararProducto() {
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (input.closest('cart-items-component, .cart-items, .cart-drawer, form[action="/cart"]')) return;
      if (input.dataset.todumiMax) return;
      input.dataset.todumiMax = '1';
      input.max = MAX_UNIDADES;
      input.setAttribute('data-max', MAX_UNIDADES);
      input.addEventListener('input', function () { limitarCantidad(input); });
      input.addEventListener('change', function () { limitarCantidad(input); });
    });
  }
  // Botón "+" del selector: si ya está en 3, se frena y se explica.
  document.addEventListener('click', function (ev) {
    var mas = ev.target.closest && ev.target.closest('button[name="plus"], .quantity__button--plus, button[aria-label*="umentar"], button[aria-label*="ncrease"]');
    if (!mas) return;
    var cont = mas.closest('quantity-selector-component, .quantity-selector, .quantity');
    var input = cont && cont.querySelector('input[name="quantity"], input[type="number"]');
    if (!input || input.closest('cart-items-component, .cart-items, .cart-drawer, form[action="/cart"]')) {
      if (input) controlarLuego();
      return;
    }
    if (Number(input.value) >= MAX_UNIDADES) { ev.preventDefault(); ev.stopImmediatePropagation(); notaProducto(input, true); }
  }, true);

  var habia = 0;
  function aplicar() {
    ponerCampo();
    prepararProducto();
    var n = document.querySelectorAll('.todumi-cuit').length;
    if (n !== habia) { habia = n; controlarLuego(); }
  }
  document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('cart-items-component, .cart-items, .cart-drawer, form[action="/cart"]')) controlarLuego(); }, true);
  new MutationObserver(aplicar).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', aplicar);
  aplicar();
})();
